import React from "react";
import { Button, ButtonProps, Popup, SemanticCOLORS } from "semantic-ui-react";

type Props = {
  icon?: string;
  text?: string;
  onClick?: ((event: React.MouseEvent<HTMLButtonElement, MouseEvent>, data: ButtonProps) => void) | undefined;
  loading?: boolean;
  disabled?: boolean;
  hint: string;
  color?: SemanticCOLORS;
};

const DetailsBoxActionButton = ({ icon, text, onClick, loading, disabled, hint, color }: Props) => {
  return (
    <Popup
      content={hint}
      mouseEnterDelay={1000}
      size="tiny"
      trigger={
        <Button
          circular
          floated="right"
          style={{ padding: "5px 7px", marginLeft: "8px", "box-shadow": "0px 0px" }}
          icon={icon}
          onClick={onClick}
          loading={loading}
          disabled={disabled}
          color={color}
        >
          {text && <>{text}</>}
        </Button>
      }
    />
  );
};

export default DetailsBoxActionButton;
